import {createAsyncThunk} from "@reduxjs/toolkit";
import {IEntityWithIDTranslations,IErrorResponse,IRootState} from "../../../../../../../types";
import request from "../../../../../../../service";
import {deletedStudentsStatus,setStudentsStatus, updateStudentsStatus} from "./studentsStatusSlice";




const GetStudentsStatus = createAsyncThunk(
    "get/students/status",
    async (_, { dispatch,rejectWithValue,getState }) => {
        try {
            const response = await request.get("/student-status");
            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage

            dispatch(setStudentsStatus({data:response.data,defaultLanguage}));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const DeleteStudentsStatus = createAsyncThunk(
    "delete/students/status",
    async ( id : number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/student-status/${id}`);

            dispatch(deletedStudentsStatus(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditStudentsStatus = createAsyncThunk(
    "edit/students/status",
    async (data: IEntityWithIDTranslations, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/student-status/${data.id}`, data);
            dispatch(updateStudentsStatus(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);





export {
    GetStudentsStatus,
    DeleteStudentsStatus,
    EditStudentsStatus,

};
